module.exports = __webpack_public_path__ + "72b785ef62a1bbf13884b4b6e3cf6d95.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-30.svg
// module id = 571
// module chunks = 0